<template>
  <div class="zk_btn_group_cla">
    <!-- <slot v-bind:items="items"> -->
    <el-button-group v-if="isGroup">
      <template v-for="btn of items">
        <span
          :class="['btn-text-cla', textClass]"
          :key="btn.id"
          @click="emit(btn.resourceEvent)"
          v-if="onlyShowText"
        >
          {{ getButtonName(btn) }}
        </span>

        <el-tooltip
          :key="btn.id"
          v-else-if="showTip"
          class="item"
          effect="dark"
          :content="getTip(btn)"
          placement="bottom"
        >
          <el-button
            :title="btn.status === 0 ? this.$t('resource.disabled') : ''"
            :disabled="btn.status === 0"
            :size="size"
            :type="btn.buttonType"
            :round="btn.buttonStyle === 'round'"
            :circle="btn.buttonStyle === 'circle'"
            :plain="btn.buttonStyle === 'plain'"
            :key="btn.id"
            @click="emit(btn.resourceEvent)"
            :icon="btn.icon"
          >
            <span v-if="isShowText">{{ getButtonName(btn) }}</span>
          </el-button>
        </el-tooltip>
        <el-button
          v-else
          :title="btn.status === 0 ? this.$t('resource.disabled') : ''"
          :disabled="btn.status === 0"
          :size="size"
          :type="btn.buttonType"
          :round="btn.buttonStyle === 'round'"
          :circle="btn.buttonStyle === 'circle'"
          :plain="btn.buttonStyle === 'plain'"
          :key="btn.id"
          @click="emit(btn.resourceEvent)"
          :icon="btn.icon"
        >
          <span v-if="isShowText">{{ getButtonName(btn) }}</span>
        </el-button>
      </template>
    </el-button-group>
    <el-row v-else>
      <template v-for="btn of items">
        <el-button
          :key="btn.id"
          @click="emit(btn.resourceEvent)"
          :class="['btn-text-cla', textClass]"
          v-if="onlyShowText"
          type="text"
          >{{ getButtonName(btn) }}</el-button
        >

        <el-tooltip
          :key="btn.id"
          v-else-if="showTip"
          class="item"
          effect="dark"
          :content="getTip(btn)"
          placement="bottom"
        >
          <el-button
            :size="size"
            :title="btn.status === 0 ? this.$t('resource.disabled') : ''"
            :disabled="btn.status === 0"
            :type="btn.buttonType"
            :round="btn.buttonStyle === 'round'"
            :circle="btn.buttonStyle === 'circle'"
            :plain="btn.buttonStyle === 'plain'"
            :key="btn.id"
            @click="emit(btn.resourceEvent)"
            :icon="btn.icon"
          >
            <span v-if="isShowText">{{ getButtonName(btn) }}</span>
          </el-button>
        </el-tooltip>

        <el-button
          v-else
          :size="size"
          :title="btn.status === 0 ? this.$t('resource.disabled') : ''"
          :disabled="btn.status === 0"
          :type="btn.buttonType"
          :round="btn.buttonStyle === 'round'"
          :circle="btn.buttonStyle === 'circle'"
          :plain="btn.buttonStyle === 'plain'"
          :key="btn.id"
          @click="emit(btn.resourceEvent)"
          :icon="btn.icon"
        >
          <span v-if="isShowText">{{ getButtonName(btn) }}</span>
        </el-button>
      </template>
    </el-row>
    <!-- </slot> -->
  </div>
</template>
<script>
import { getResourceByGroupName } from '../../../services/resource'
export default {
  name: 'ZkButtonGroup',
  data() {
    return {
      butttons: []
    }
  },
  props: {
    params: {
      type: Object,
      default: function() {
        return {}
      }
    },
    showTip: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    },
    showText: {
      type: Boolean,
      default: true
    },
    textClass: {
      type: String,
      default: 'btn-text__success'
    },
    onlyShowText: {
      type: Boolean,
      default: false
    },
    isGroup: {
      type: Boolean,
      default: false
    },
    groupName: {
      type: String,
      default: 'all'
    },
    toolBar: {
      type: Boolean,
      default: false
    },
    event: {
      type: Array,
      default: function() {
        return []
      }
    },
    eventTip: {
      type: Object,
      default: function() {
        return {}
      }
    },
    isLoadGroupName: {
      // 如果按钮组名不为空，是否根据组名加载按钮
      type: Boolean,
      default: false
    }
  },
  watch: {
    event: {
      handler(val) {
        if (val) {
          this.loadButtonGroup()
        }
      },
      immediate: true
    }
  },
  computed: {
    isShowText() {
      if (typeof this.showText === 'undefined') {
        return true
      } else {
        return this.showText
      }
    },

    items() {
      let _this = this
      if (this.isLoadGroupName && this.groupName && this.groupName !== 'all') {
        return this.butttons
      } else if (_this.$root.activeMenu && _this.$root.activeMenu.children) {
        let btns = _this.$root.activeMenu.children

        let result = this.filterBtn(btns)
        return result
      } else {
        return []
      }
    }
  },
  mounted() {
    if (this.isLoadGroupName && this.groupName && this.groupName !== 'all') {
      this.loadButtonGroup()
    }
  },
  methods: {
    getTip(btn) {
      let tip = this.eventTip[btn.resourceEvent]
      if (tip) {
        return tip
      }
      return btn.name
    },
    filterBtn(buttons) {
      let _this = this
      buttons = buttons || []
      return buttons.filter(item => {
        if (_this.event.length > 0) {
          let len = _this.event.length
          for (let i = 0; i < len; i++) {
            if (_this.event[i] === item.resourceEvent) {
              return true
            }
          }
          return false
        }
        if (_this.groupName === 'all' || _this.groupName === '') {
          return (
            item.resourceType + '' === '2' ||
            (_this.toolBar && item.resourceType + '' === '3')
          )
        } else {
          return (
            (item.resourceType + '' === '2' ||
              (_this.toolBar && item.resourceType + '' === '3')) &&
            item.groupName === _this.groupName
          )
        }
      })
    },
    loadButtonGroup() {
      getResourceByGroupName(this.groupName)
        .then(data => {
          this.butttons = this.filterBtn(data)
        })
        .catch(data => {})
    },
    getButtonName(Info) {
      // let i18nKey = Info['i18nKey']
      // if (i18nKey) {
      //   let value = this.$t(i18nKey)
      //   if (value !== i18nKey) {
      //     return value
      //   }
      // }
      return Info.name
    },
    emit(event) {
      this.$emit(event, this.params)
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/styles/var.less';
.btn-text__success {
  color: @statusSuccess;
}
.btn-text__failed {
  color: @ststusFailed;
}
.btn-text__normal {
  color: @statusNormal;
}
.btn-text__warning {
  color: @statusWarning;
}
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/buttonGroup/src/main.vue